import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Secretariat = types.compose(
  BaseEntity,
  types
    .model('Secretariat', {
      secretariatId: types.identifierNumber,
      name: types.string,
      code: types.string,
      address: types.maybe(types.string),
      zipCode: types.maybe(types.string),
      city: types.maybe(types.string),
      website: types.maybe(types.string),
      phoneNumber: types.maybe(types.string),
      mailAddress: types.maybe(types.string),
      language: types.string,
      isActive: types.boolean,
    })
    .actions((self) => {
      const setName = (name: string) => {
        self.name = name;
      };
      const setCode = (code: string) => {
        self.code = code;
      };
      const setAddress = (address: string) => {
        self.address = address;
      };
      const setLanguage = (language: string) => {
        self.language = language;
      };
      const setIsActive = (isActive: boolean) => {
        self.isActive = isActive;
      };
      return {
        setName,
        setCode,
        setAddress,
        setLanguage,
        setIsActive,
      };
    }),
);
